/*
 * @Description: 开票地址卡片
 * @Author: ywj
 * @Date: 2025-03-04 17:00:30
 * @LastEditTime: 2025-04-07 15:53:41
 * @LastEditors: Please set LastEditors
 */
import React from "react";
import './index.scss';
import { IInvoiceItem } from '../../type';
import { setDefaultBill } from '@/api/personal-center'
import { message } from "antd";
interface ICardProps extends IInvoiceItem{ 
 
  handleEdit:(props:ICardProps)=>void,
  handleDelete:(props:ICardProps)=>void,
  handleInvoiceData: () => void,
  //我的发票需要的数据
  canChecked?: boolean //我的发票需要有选中效果，开票信息模块不需要
  onClick?: (id: number) => void;
  invoiceId?:number
}
const Card: React.FC<ICardProps> = (props) => {
  const { canChecked = false} = props
  const handleDefaultBill =(id:number)=>{
    setDefaultBill(id).then((res: any) => {
      if (res.success) { 
        message.success('操作成功');
        props?.handleInvoiceData();
      } else {
        message.error(res.message);
      }
    })
  }
  return <div className="invoice-card-content">
    <div className={`cell ${canChecked&&props.invoiceId === props.id && 'active'}`} onClick={() => props.onClick && props.onClick(props.id)}>
      <div className="line1">
        <div className="line1-left">
          <span>{props?.type===1||props?.type===2?'数电普通发票':'数电专用发票'}</span>
          {props.defaultStatus===1 && <span className="default-bg">默认</span>}
        </div>
        <div className="line1-right">
          {props.defaultStatus===0 && <span onClick={() => handleDefaultBill(props.id)}>设为默认</span>}
          <span onClick={() => props.handleEdit(props)}>修改</span>
          <span onClick={() => props.handleDelete(props)}>删除</span>
        </div>
      </div>
      <div className="line2">
        <span className='text'>发票抬头：</span>
        {/* {props?.type===1&&<span>个人&nbsp;&nbsp;</span>} */}
        <span className="header">{props.header}</span>
      </div>
      {props?.type!==1 && <div className="invoice-num"><span className='text'>纳税人识别号：</span>{props.code}</div>}
    </div>
  </div>;
}

export default Card;
